import { isIos } from "@app/utils/isIosSafari";

const Favourites = (() => {
    let favouritesList: Array<string> = [];
    let options = {
        element: 'product-card',
        favouriteButtons: 'product-card__favourite-button',
        handle: 'data-product-handle',
        addedClass: 'favourite--added'
    };
    const init = (args = {}) => {
        options = Object.assign(options, args);
        const favouritesString = localStorage.getItem('favourites');
        if (favouritesString) {
            favouritesList = JSON.parse(favouritesString);
        }
    }
    const initButtons = () => {
        const productCards = document.getElementsByClassName(options.element);
        if (productCards.length > 0) {
            [].forEach.call(productCards, function (card: Element) {
                const favouriteButtons = card.getElementsByClassName(options.favouriteButtons);
                if (favouriteButtons.length > 0) {
                    const favouriteButton = favouriteButtons[0];
                    const productHandle = favouriteButton.getAttribute(options.handle);
                    if (productHandle) {
                        if (isInFavourites(productHandle)) {
                            favouriteButton.classList.add(options.addedClass);
                        }

                        if (isIos()) {
                            favouriteButton.removeEventListener("mouseover", iosMobileHandle)
                            favouriteButton.addEventListener("mouseover", iosMobileHandle)
                        }
                        favouriteButton.removeEventListener('click', handleClick); // Ensure no duplicate listeners
                        favouriteButton.addEventListener('click', handleClick);
                    }
                }
            });
        }
    };

    const iosMobileHandle = (event: Event) => {
        handleClick(event)
    }

    const handleClick = (event: Event) => {
        const button = event.currentTarget as HTMLElement;
        const productHandle = button.getAttribute(options.handle);

        if (productHandle) {
            if (isInFavourites(productHandle)) {
                if (removeFavourite(productHandle)) {
                    button.classList.remove(options.addedClass);
                }
            } else {
                if (addFavourite(productHandle)) {
                    button.classList.add(options.addedClass);
                }
            }
        }
    };

    const getAll = () => {
        return favouritesList;
    };
    const addFavourite = (productHandle: string) => {
        if (!isInFavourites(productHandle)) {
            favouritesList.push(productHandle);
            localStorage.setItem('favourites', JSON.stringify(favouritesList));
            triggerChange();
        }
        return true;
    };

    const removeFavourite = (productHandle: string) => {
        const index = favouritesList.indexOf(productHandle);
        if (index > -1) {
            favouritesList.splice(index, 1);
            localStorage.setItem('favourites', JSON.stringify(favouritesList));
            triggerChange();
        }
        return true;
    };
    const triggerChange = () => {
        const event = new CustomEvent('favourites-change', { detail: { favourites: favouritesList } });
        window.dispatchEvent(event);
    };

    const isInFavourites = (productHandle: string) => {
        return favouritesList.includes(productHandle);
    };
    return {
        init,
        initButtons,
        getAll,
        addFavourite,
        removeFavourite,
        isInFavourites
    }
})();

export default Favourites;